import _extends from "@babel/runtime/helpers/extends";
import React, { useState, useEffect } from "react";

// Components
import Icon from "../../Icon";
import Modal from "../../Modal";
import Banner from "../../Banner";
import { QRCodeCanvas } from "qrcode.react";

// Styles
import defaultClasses from "./myAccountHeader.module.scss";
import { mergeClasses } from "@magento/venia-ui/lib/classify";

//Assets
import img_birthday from "@Assets/images/area-personale/Torta.png";

//Hooks
import { useUserContext } from "@magento/peregrine/lib/context/user";
import { useCouponContext } from "@overrides_venia/peregrine/context/coupon";
import { useIntl } from "react-intl";
import { format } from "date-fns";

//Redux
import { useDispatch } from "react-redux";
import { setModalBookATableOpen } from "@Redux/bookTable/BookTable.actions";
import { useWindowSize } from "@overrides_venia/peregrine/hooks/useWindowSize";
import { useExponea } from "@Src_main/utils/useExponea";
import { MoneyBox, SeedsBox, getBackgroundDesktop, getBackgroundMobile, getRange, getBackgroundColorFiller } from "../seedsUtils";
import Button from "@overrides_venia/venia-ui/components/Button/button";
import { useHistory, useLocation } from "@magento/venia-ui/lib/drivers";
import { bgImage } from "@Src_main/utils/generalUtils";
import { env } from "build/env";
import { isOrderActive, homepageUrl } from "@Components/LinkBetween/miScusiAndTakeAwayUtils";
var Header = _ref => {
  var _currentUser$lsAccoun, _currentUser$dob, _currentUser$lsAccoun2, _currentUser$lsAccoun3, _currentUser$lsAccoun4, _location$state;
  var {
    isOuterQR,
    setIsModalOpenProp,
    showQrCode = true,
    isMiniCart = false,
    isModalOpen,
    setIsModalOpen
  } = _ref;
  var {
    isMobile,
    innerHeight,
    innerWidth
  } = useWindowSize();
  var classes = mergeClasses(defaultClasses);
  var {
    userCoupons
  } = useCouponContext();
  var {
    formatMessage
  } = useIntl();
  var [{
    currentUser
  }] = useUserContext();
  var dispatch = useDispatch();
  var {
    trackEvent
  } = useExponea();
  var history = useHistory();
  var location = useLocation();
  var {
    IS_COUPON_ACTIVE
  } = env;
  var [iframeScale, setIframeScale] = useState(1); // State to store the scale value

  var landscapeBaselineWidth = 1920;
  var landscapeBaselineHeight = 1080;
  var mobileHeight = 380;
  var GoBack = () => {
    if (location.state && location.state.from) {
      history.push(location.state.from);
    } else {
      // Fallback to a default route if no previous URL is available
      history.goBack();
    }
  };
  var goHome = () => {
    history.push(homepageUrl);
  };
  useEffect(() => {
    if (innerWidth && innerHeight) {
      var srcFormFactor = landscapeBaselineHeight / landscapeBaselineWidth;
      var currentFormFactor = isMobile ? 380 / innerWidth : innerHeight / innerWidth;
      var newScale = currentFormFactor < srcFormFactor ? srcFormFactor / currentFormFactor : currentFormFactor / srcFormFactor;

      // Apply the calculated scale
      setIframeScale(newScale);
    }
  }, [innerWidth, innerHeight, isMobile]);
  /**
   *
   * @param {boolean} willOpen
   */
  var setBookTableModalOpen = willOpen => {
    dispatch(setModalBookATableOpen(!!willOpen));
  };
  useEffect(() => {
    if (isModalOpen) {
      trackEvent("click_show_loyalty", {}, false);
    }
  }, [isModalOpen]);
  var qrCode = (currentUser === null || currentUser === void 0 ? void 0 : (_currentUser$lsAccoun = currentUser.lsAccount) === null || _currentUser$lsAccoun === void 0 ? void 0 : _currentUser$lsAccoun.card_id) || "";
  var dob = currentUser === null || currentUser === void 0 ? void 0 : (_currentUser$dob = currentUser.dob) === null || _currentUser$dob === void 0 ? void 0 : _currentUser$dob.substring(5);
  var currentDate = format(new Date(), "MM-dd");
  var totalPoints = currentUser !== null && currentUser !== void 0 && (_currentUser$lsAccoun2 = currentUser.lsAccount) !== null && _currentUser$lsAccoun2 !== void 0 && (_currentUser$lsAccoun3 = _currentUser$lsAccoun2.scheme) !== null && _currentUser$lsAccoun3 !== void 0 && _currentUser$lsAccoun3.point_balance ? parseInt(currentUser.lsAccount.scheme.point_balance) : 0;
  var totalCoupons = userCoupons && (userCoupons === null || userCoupons === void 0 ? void 0 : userCoupons.length);
  var customerName = currentUser.firstname;
  var customerCardNumber = currentUser === null || currentUser === void 0 ? void 0 : (_currentUser$lsAccoun4 = currentUser.lsAccount) === null || _currentUser$lsAccoun4 === void 0 ? void 0 : _currentUser$lsAccoun4.card_id;
  var modalQrCode = currentUser.email ? /*#__PURE__*/React.createElement(Modal, {
    id: "modal-qr-code",
    nameClass: "modal-qr-code",
    isOpen: isModalOpen,
    modalCloseOutside: false,
    closeButtonClass: "uk-modal-close-default",
    modalDialogClass: "uk-border-rounded uk-overflow-hidden uk-background-light-green",
    modalHeigthClass: "uk-height-1-1",
    onClose: () => setIsModalOpen(false)
  }, /*#__PURE__*/React.createElement("div", {
    className: "content-qr-code uk-text-white uk-flex uk-flex-column uk-flex-middle uk-text-center"
  }, /*#__PURE__*/React.createElement("h3", {
    className: "title uk-text-uppercase uk-text-normal"
  }, totalPoints < 2500 ? /*#__PURE__*/React.createElement("div", {
    className: "money-info ".concat(classes.info)
  }, formatMessage({
    id: "loyalty.seeds.message3"
  }), getRange(totalPoints) - totalPoints, formatMessage({
    id: "loyalty.seeds.message4"
  })) : null), /*#__PURE__*/React.createElement("div", {
    className: "action uk-text-bold"
  }, customerCardNumber), /*#__PURE__*/React.createElement(QrCodeLoyalty, {
    qrSize: 300,
    qrCode: qrCode
  }), /*#__PURE__*/React.createElement("div", {
    className: "action uk-text-bold"
  }, formatMessage({
    id: "myaccount.qrcode.loyalty.action4"
  })))) : null;
  var bannerBirthday = currentDate == dob && !isMobile ? /*#__PURE__*/React.createElement("div", {
    className: "banner ".concat(classes.banner),
    onClick: () => setBookTableModalOpen(true)
  }, /*#__PURE__*/React.createElement(Banner, {
    image: img_birthday,
    title: formatMessage({
      id: "loyalty.happy.birthday"
    }),
    subtitle: formatMessage({
      id: "loyalty.book.message"
    }),
    bgColor: "#556D67"
  })) : null;
  var qrCodeInner = /*#__PURE__*/React.createElement(React.Fragment, null, isOuterQR ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
    color: "dark-green",
    fullScreen: true,
    type: "button",
    extraClass: "uk-position-bottom",
    onClick: () => {
      if (setIsModalOpenProp) setIsModalOpenProp(false);
      history.push(formatMessage({
        id: "url.key.myaccount"
      }));
    }
  }, formatMessage({
    id: "loyalty.header.home"
  }))) : null, !isOuterQR ? bannerBirthday : null);
  var loyaltyBackground = totalPoints < 500 ? /*#__PURE__*/React.createElement(SeedsBox, {
    totalPoints: totalPoints,
    classes: classes
  }, showQrCode ? qrCodeInner : null) : /*#__PURE__*/React.createElement(MoneyBox, {
    totalPoints: totalPoints,
    classes: classes
  }, showQrCode ? qrCodeInner : null);
  var loyaltyStats = /*#__PURE__*/React.createElement("div", {
    className: defaultClasses.loyaltyStats
  }, /*#__PURE__*/React.createElement("div", {
    className: defaultClasses.welcomeContainer
  }, /*#__PURE__*/React.createElement("h2", {
    className: defaultClasses.headBig
  }, formatMessage({
    id: "header.login.ciao"
  }), /*#__PURE__*/React.createElement("br", null), " ", customerName)), /*#__PURE__*/React.createElement("div", {
    className: defaultClasses.statsContainer
  }, IS_COUPON_ACTIVE ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: defaultClasses.headBig
  }, !totalCoupons ? 0 : totalCoupons), /*#__PURE__*/React.createElement("h3", {
    className: defaultClasses.headMedium
  }, formatMessage({
    id: "loyalty.area.coupon.header"
  })), /*#__PURE__*/React.createElement("p", {
    className: defaultClasses.bodySmall
  }, formatMessage({
    id: "loyalty.area.coupon.details"
  })), /*#__PURE__*/React.createElement("a", {
    onClick: () => history.push(formatMessage({
      id: "url.key.coupon"
    })),
    className: defaultClasses.buttonLink
  }, formatMessage({
    id: "get.details"
  }))) : null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: defaultClasses.headBig
  }, totalPoints), /*#__PURE__*/React.createElement("h3", {
    className: defaultClasses.headMedium
  }, formatMessage({
    id: "loyalty.area.points.header"
  })), /*#__PURE__*/React.createElement("p", {
    className: defaultClasses.bodySmall
  }, formatMessage({
    id: "loyalty.area.points.details"
  })), /*#__PURE__*/React.createElement("a", {
    onClick: () => history.push(formatMessage({
      id: "url.key.loyalty.history"
    })),
    className: defaultClasses.buttonLink
  }, formatMessage({
    id: "button.scopri_di_piu"
  })))), showQrCode ? qrCodeInner : null);
  var iconHeader = isOrderActive ? "icon-arrow-left" : "icon-home";
  var isComingFromOrder = (_location$state = location.state) === null || _location$state === void 0 ? void 0 : _location$state.from;
  var headerStandard = /*#__PURE__*/React.createElement(React.Fragment, null, isComingFromOrder || !isMobile ? /*#__PURE__*/React.createElement("div", {
    className: "uk-position-absolute"
  }, /*#__PURE__*/React.createElement(Icon, {
    onClick: isOrderActive ? GoBack : goHome,
    name: iconHeader,
    color: "white",
    isCircled: isOrderActive ? true : false,
    containerClass: "uk-padding-small",
    justifyStart: false
  })) : null, /*#__PURE__*/React.createElement("div", _extends({
    className: "content  ".concat(classes.content, "  ").concat(isOuterQR ? "uk-height-1-1" : "uk-height-xxlarge", " ")
  }, !isOuterQR && !isMobile ? {
    "data-uk-height-viewport": "min-height: 900"
  } : {}), /*#__PURE__*/React.createElement("div", {
    style: {
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      height: isMobile ? '380px' : '100%',
      zIndex: -1
    }
  }, /*#__PURE__*/React.createElement("iframe", {
    src: "https://customer-qr3pojwmnn30473r.cloudflarestream.com/f1a6c9aa52bc887e3b626e116a0b09fb/iframe?muted=true&loop=true&autoplay=true&poster=https%3A%2F%2Fcustomer-qr3pojwmnn30473r.cloudflarestream.com%2Ff1a6c9aa52bc887e3b626e116a0b09fb%2Fthumbnails%2Fthumbnail.jpg%3Ftime%3D%26height%3D600&controls=false",
    loading: "lazy",
    style: {
      border: 'none',
      position: 'absolute',
      top: 0,
      left: 0,
      height: '100%',
      width: '100%',
      scale: "".concat(iframeScale) // Dynamically adjust the scale
    },
    allow: "accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture",
    allowFullScreen: true
  })), loyaltyStats), modalQrCode);
  var headerMiniCart = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "content uk-background-cover  ".concat(classes.content, "  "),
    style: {
      backgroundImage: bgImage(getBackgroundDesktop(totalPoints))
    }
  }, loyaltyBackground));
  return isMiniCart ? headerMiniCart : headerStandard;
};
var QrCodeLoyalty = _ref2 => {
  var {
    qrSize,
    qrCode,
    onClick
  } = _ref2;
  return /*#__PURE__*/React.createElement("div", {
    id: "qr-code-loyalty",
    style: {
      height: "auto",
      margin: "0 auto",
      maxWidth: qrSize,
      width: "100%"
    },
    onClick: onClick
  }, /*#__PURE__*/React.createElement(QRCodeCanvas, {
    value: qrCode,
    includeMargin: true,
    size: qrSize,
    style: {
      borderRadius: "10px",
      margin: "10px 0px"
    }
  }));
};
export default Header;